// COMMON Right Arrow FOR SLIDER

export const CommonRightArrowIcon = () => {
  return (
    <svg
      className=" mx-auto"
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none">
      <path
        d="M11.696 7.53545C11.5477 7.68347 11.43 7.85929 11.3497 8.05285C11.2694 8.24641 11.2281 8.4539 11.2281 8.66345C11.2281 8.873 11.2694 9.08049 11.3497 9.27405C11.43 9.46761 11.5477 9.64343 11.696 9.79145L17.904 15.9994L11.696 22.2074C11.3969 22.5066 11.2288 22.9124 11.2288 23.3354C11.2288 23.7585 11.3969 24.1643 11.696 24.4635C11.9952 24.7626 12.4009 24.9307 12.824 24.9307C13.2471 24.9307 13.6529 24.7626 13.952 24.4635L21.296 17.1194C21.4444 16.9714 21.562 16.7956 21.6423 16.602C21.7226 16.4085 21.7639 16.201 21.7639 15.9914C21.7639 15.7819 21.7226 15.5744 21.6423 15.3809C21.562 15.1873 21.4444 15.0115 21.296 14.8634L13.952 7.51945C13.344 6.91145 12.32 6.91145 11.696 7.53545Z"
        fill="white"
      />
    </svg>
  );
};
// COMMON LEFT Arrow FOR SLIDER

export const CommonLeftArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none">
      <path
        d="M20.9706 7.53545C21.1189 7.68347 21.2366 7.85929 21.3169 8.05285C21.3971 8.24641 21.4385 8.4539 21.4385 8.66345C21.4385 8.873 21.3971 9.08049 21.3169 9.27405C21.2366 9.46761 21.1189 9.64343 20.9706 9.79145L14.7626 15.9994L20.9706 22.2074C21.2697 22.5066 21.4378 22.9124 21.4378 23.3354C21.4378 23.7585 21.2697 24.1643 20.9706 24.4635C20.6714 24.7626 20.2656 24.9307 19.8426 24.9307C19.4195 24.9307 19.0137 24.7626 18.7146 24.4635L11.3706 17.1194C11.2222 16.9714 11.1046 16.7956 11.0243 16.602C10.944 16.4085 10.9027 16.201 10.9027 15.9914C10.9027 15.7819 10.944 15.5744 11.0243 15.3809C11.1046 15.1873 11.2222 15.0115 11.3706 14.8634L18.7146 7.51945C19.3226 6.91145 20.3466 6.91145 20.9706 7.53545Z"
        fill="white"
      />
    </svg>
  );
};

// DROPDOWN ARROW
export const DropDownIcon = () => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M2 1.5L6 5.5L10 1.5" stroke="white" />
    </svg>
  );
};

//SIDE TAKE SHOT XMILD ICON
export const CommonXmildIcon = () => {
  return (
    <svg
      width="73"
      height="79"
      viewBox="0 0 73 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.17272 36.8999C6.71185 37.0075 6.4256 37.4682 6.53324 37.9291C6.64087 38.3899 7.10156 38.6762 7.56244 38.5685C8.02331 38.4609 8.30956 38.0002 8.20192 37.5393C8.09428 37.0785 7.63359 36.7922 7.17272 36.8999ZM7.49563 38.2825C7.19368 38.353 6.89777 38.1624 6.8291 37.8683C6.75858 37.5664 6.94923 37.2705 7.24324 37.2018C7.53725 37.1332 7.84111 37.322 7.90977 37.616C7.97844 37.91 7.79758 38.212 7.49563 38.2825Z"
        fill="url(#paint0_linear_214_3019)"
      />
      <path
        d="M14.8832 41.4257C14.4223 41.5334 14.1361 41.9941 14.2437 42.4549C14.3513 42.9158 14.812 43.2021 15.2729 43.0944C15.7338 42.9868 16.02 42.5261 15.9124 42.0652C15.8047 41.6044 15.344 41.3181 14.8832 41.4257ZM15.2061 42.8084C14.9041 42.8789 14.6082 42.6882 14.5395 42.3942C14.469 42.0923 14.6597 41.7964 14.9537 41.7277C15.2556 41.6572 15.5516 41.8478 15.6202 42.1418C15.6968 42.434 15.508 42.7378 15.2061 42.8084Z"
        fill="url(#paint1_linear_214_3019)"
      />
      <path
        d="M8.50243 42.916C8.04156 43.0236 7.75531 43.4843 7.86295 43.9452C7.97059 44.4061 8.43128 44.6923 8.89215 44.5847C9.35302 44.477 9.63927 44.0163 9.53163 43.5555C9.424 43.0946 8.96331 42.8083 8.50243 42.916ZM8.82534 44.2986C8.52339 44.3691 8.22748 44.1785 8.15881 43.8845C8.08829 43.5825 8.27895 43.2866 8.57295 43.2179C8.8749 43.1474 9.17082 43.3381 9.23948 43.6321C9.30815 43.9261 9.12729 44.2281 8.82534 44.2986Z"
        fill="url(#paint2_linear_214_3019)"
      />
      <path
        d="M6.94899 35.7624L7.59263 35.6121L12.7214 38.5202L13.4846 38.9537L22.2275 32.1858L14.2295 30.1237L6.94899 35.7624ZM18.5308 26.798L22.2409 27.7582L26.5306 28.868L30.7599 25.5927L22.7619 23.5306L18.5308 26.798ZM35.5698 13.6095L39.28 14.5697L43.5697 15.6795L47.7989 12.4041L39.8009 10.3421L35.5698 13.6095ZM52.2828 1.78751C51.984 1.40481 51.4309 1.33288 51.0561 1.62989L44.1003 7.00843L47.8105 7.96866L52.1002 9.07844L55.7484 6.25723L52.2828 1.78751ZM27.0533 20.1988L30.7635 21.1591L35.0453 22.2707L39.2745 18.9954L31.2765 16.9333L27.0533 20.1988Z"
        fill="url(#paint3_linear_214_3019)"
      />
      <path
        d="M16.0283 40.5886L12.6398 38.6734L7.56805 35.7939L6.20132 36.1131C5.7325 36.2225 5.43222 36.6949 5.54357 37.1717L5.7143 37.9027L6.82778 42.6704L7.16182 44.1007C7.36967 44.9906 8.26165 45.5448 9.15161 45.337L15.5562 43.8412C17.1215 43.4756 17.4273 41.3764 16.0283 40.5886ZM8.89214 44.5848C8.43126 44.6924 7.97057 44.4062 7.86294 43.9453C7.7553 43.4844 8.04154 43.0237 8.50242 42.9161C8.96329 42.8085 9.42398 43.0947 9.53162 43.5556C9.63925 44.0164 9.35301 44.4771 8.89214 44.5848ZM7.56252 38.5688C7.10164 38.6764 6.64096 38.3902 6.53332 37.9293C6.42568 37.4684 6.71193 37.0077 7.1728 36.9001C7.63367 36.7924 8.09436 37.0787 8.202 37.5396C8.30964 38.0004 8.02339 38.4611 7.56252 38.5688ZM15.2729 43.0946C14.812 43.2022 14.3513 42.916 14.2437 42.4551C14.136 41.9942 14.4223 41.5335 14.8831 41.4259C15.344 41.3182 15.8047 41.6045 15.9123 42.0654C16.02 42.5262 15.7337 42.9869 15.2729 43.0946Z"
        fill="url(#paint4_linear_214_3019)"
      />
      <path
        d="M47.6876 45.2948L29.5546 49.5298L31.6126 58.342L49.7457 54.1071L47.6876 45.2948Z"
        fill="url(#paint5_linear_214_3019)"
      />
      <path
        d="M60.011 30.2496L58.1691 34.2746L56.5138 37.879L51.2296 39.1131L54.7269 31.4837L49.5222 32.6993L49.532 32.7054L47.6821 36.7322L46.0268 40.3366L40.7426 41.5707L44.2399 33.9413L39.0352 35.1569L39.045 35.163L37.1951 39.1898L35.5398 42.7942L30.2397 44.032L33.737 36.4027L28.5323 37.6182L28.5421 37.6243L26.6922 41.6512L25.0369 45.2555L19.7527 46.4896L23.25 38.8603L16.1938 40.5082C16.8524 40.9242 17.1895 41.6499 17.0766 42.4221C16.9631 43.2279 16.3953 43.8465 15.5928 44.0339L9.18819 45.5297C8.47304 45.6967 7.76284 45.4185 7.33388 44.8734L15.0225 77.7941C15.132 78.263 15.6043 78.5632 16.0811 78.4519L72.0455 65.3815C72.5143 65.272 72.8146 64.7997 72.7032 64.3229L64.5006 29.2011L60.011 30.2496ZM67.2986 60.6999L18.2712 72.1502L18.1765 71.7449L67.2119 60.2928L67.3066 60.698L67.2986 60.6999ZM66.5415 57.4579L17.514 68.9081L17.4193 68.5029L66.4547 57.0507L66.5494 57.456L66.5415 57.4579ZM65.7824 54.2079L16.755 65.6582L16.6603 65.2529L65.6957 53.8008L65.7904 54.206L65.7824 54.2079ZM62.8725 41.7484L48.0928 45.2002L50.1509 54.0124L64.9306 50.5606L65.0253 50.9659L50.2455 54.4177L49.8403 54.5123L31.7072 58.7473L31.302 58.8419L15.9978 62.4162L15.9032 62.0109L31.2153 58.4348L29.1572 49.6226L13.8451 53.1987L13.7504 52.7934L62.7858 41.3413L62.8805 41.7465L62.8725 41.7484Z"
        fill="url(#paint6_linear_214_3019)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_214_3019"
          x1="6.33838"
          y1="37.0947"
          x2="8.39678"
          y2="38.3737"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_214_3019"
          x1="14.0488"
          y1="41.6206"
          x2="16.1072"
          y2="42.8996"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_214_3019"
          x1="7.66809"
          y1="43.1108"
          x2="9.72649"
          y2="44.3898"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_214_3019"
          x1="1.65271"
          y1="13.085"
          x2="33.7651"
          y2="50.8772"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_214_3019"
          x1="5.34314"
          y1="36.3135"
          x2="17.0113"
          y2="43.856"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_214_3019"
          x1="29.5546"
          y1="49.5298"
          x2="39.813"
          y2="62.1689"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_214_3019"
          x1="6.81982"
          y1="42.6724"
          x2="51.2322"
          y2="86.9289"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
      </defs>
    </svg>
  );
};

//SEARCH ICON
export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M10 18C11.775 17.9996 13.4988 17.4054 14.897 16.312L19.293 20.708L20.707 19.294L16.311 14.898C17.405 13.4997 17.9996 11.7754 18 10C18 5.589 14.411 2 10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18ZM10 4C13.309 4 16 6.691 16 10C16 13.309 13.309 16 10 16C6.691 16 4 13.309 4 10C4 6.691 6.691 4 10 4Z"
        fill="white"
      />
    </svg>
  );
};
// BACK TO TOP
export const BackToTopIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="white"
      className="bi bi-chevron-double-up"
      viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708l6-6z"
      />
      <path
        fillRule="evenodd"
        d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
      />
    </svg>
  );
};

// FAN-FAVORITES
export const HeartIcon = ({ filled }) => {
  return (
    <svg
      id="icon1"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={filled ? "#FF0000" : "none"}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z"
        fill=""
        stroke="#FF0000"
        strokeWidth="2px"
      />
    </svg>
  );
};
// FAQ ARROW
export const FaqArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none">
      <path d="M7.5 11.25L15 18.75L22.5 11.25" stroke="white" strokeWidth="2" />
    </svg>
  );
};

// FOOTER SOCIAL ICON HERE
export const FooterInstaIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_b_214_3245)">
        <rect width="36" height="36" rx="18" fill="white" fillOpacity="0.04" />
        <path
          d="M17.9978 15.3322C16.5289 15.3322 15.3301 16.531 15.3301 18C15.3301 19.469 16.5289 20.6678 17.9978 20.6678C19.4668 20.6678 20.6656 19.469 20.6656 18C20.6656 16.531 19.4668 15.3322 17.9978 15.3322ZM25.9991 18C25.9991 16.8953 26.0091 15.8005 25.9471 14.6978C25.885 13.4169 25.5928 12.2801 24.6562 11.3435C23.7176 10.4049 22.5829 10.1147 21.302 10.0526C20.1973 9.99059 19.1026 10.0006 17.9999 10.0006C16.8951 10.0006 15.8004 9.99059 14.6977 10.0526C13.4168 10.1147 12.2801 10.4069 11.3435 11.3435C10.4049 12.2821 10.1147 13.4169 10.0526 14.6978C9.99059 15.8025 10.0006 16.8973 10.0006 18C10.0006 19.1027 9.99059 20.1995 10.0526 21.3022C10.1147 22.5831 10.4069 23.7199 11.3435 24.6565C12.2821 25.5951 13.4168 25.8853 14.6977 25.9474C15.8024 26.0094 16.8971 25.9994 17.9999 25.9994C19.1046 25.9994 20.1993 26.0094 21.302 25.9474C22.5829 25.8853 23.7196 25.5931 24.6562 24.6565C25.5948 23.7179 25.885 22.5831 25.9471 21.3022C26.0111 20.1995 25.9991 19.1047 25.9991 18ZM17.9978 22.1048C15.7264 22.1048 13.8932 20.2715 13.8932 18C13.8932 15.7285 15.7264 13.8952 17.9978 13.8952C20.2693 13.8952 22.1025 15.7285 22.1025 18C22.1025 20.2715 20.2693 22.1048 17.9978 22.1048ZM22.2707 14.6858C21.7403 14.6858 21.312 14.2575 21.312 13.7271C21.312 13.1968 21.7403 12.7685 22.2707 12.7685C22.801 12.7685 23.2293 13.1968 23.2293 13.7271C23.2294 13.853 23.2048 13.9778 23.1566 14.0942C23.1085 14.2105 23.0379 14.3163 22.9489 14.4053C22.8598 14.4944 22.7541 14.565 22.6377 14.6131C22.5213 14.6612 22.3966 14.6859 22.2707 14.6858Z"
          fill="white"
        />
        <rect
          x="0.715595"
          y="0.715595"
          width="34.5688"
          height="34.5688"
          rx="17.2844"
          stroke="url(#paint0_linear_214_3245)"
          strokeWidth="1.43119"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_214_3245"
          x="-71.5595"
          y="-71.5595"
          width="179.119"
          height="179.119"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="35.7797" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_214_3245"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_214_3245"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_214_3245"
          x1="0"
          y1="0"
          x2="36"
          y2="36"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const FooterFacebookIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_b_214_3247)">
        <rect width="36" height="36" rx="18" fill="white" fillOpacity="0.04" />
        <path
          d="M15.8984 25.125H18.8984V19.1175H21.6014L21.8984 16.1325H18.8984V14.625C18.8984 14.4261 18.9775 14.2353 19.1181 14.0947C19.2588 13.954 19.4495 13.875 19.6484 13.875H21.8984V10.875H19.6484C18.6539 10.875 17.7001 11.2701 16.9968 11.9733C16.2935 12.6766 15.8984 13.6304 15.8984 14.625V16.1325H14.3984L14.1014 19.1175H15.8984V25.125Z"
          fill="white"
        />
        <rect
          x="0.715595"
          y="0.715595"
          width="34.5688"
          height="34.5688"
          rx="17.2844"
          stroke="url(#paint0_linear_214_3247)"
          strokeWidth="1.43119"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_214_3247"
          x="-71.5595"
          y="-71.5595"
          width="179.119"
          height="179.119"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="35.7797" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_214_3247"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_214_3247"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_214_3247"
          x1="0"
          y1="0"
          x2="36"
          y2="36"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const FooterLinkdinIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_b_214_3250)">
        <rect width="36" height="36" rx="18" fill="white" fillOpacity="0.04" />
        <path
          d="M14.205 12.7498C14.2048 13.1476 14.0465 13.5291 13.7651 13.8102C13.4836 14.0914 13.102 14.2492 12.7042 14.249C12.3064 14.2488 11.9249 14.0906 11.6438 13.8092C11.3626 13.5277 11.2048 13.1461 11.205 12.7483C11.2052 12.3504 11.3634 11.969 11.6448 11.6878C11.9263 11.4067 12.3079 11.2488 12.7057 11.249C13.1035 11.2492 13.485 11.4074 13.7661 11.6889C14.0473 11.9703 14.2052 12.3519 14.205 12.7498ZM14.25 15.3598H11.25V24.7498H14.25V15.3598ZM18.99 15.3598H16.005V24.7498H18.96V19.8223C18.96 17.0773 22.5375 16.8223 22.5375 19.8223V24.7498H25.5V18.8023C25.5 14.1748 20.205 14.3473 18.96 16.6198L18.99 15.3598Z"
          fill="white"
        />
        <rect
          x="0.715595"
          y="0.715595"
          width="34.5688"
          height="34.5688"
          rx="17.2844"
          stroke="url(#paint0_linear_214_3250)"
          strokeWidth="1.43119"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_214_3250"
          x="-71.5595"
          y="-71.5595"
          width="179.119"
          height="179.119"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="35.7797" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_214_3250"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_214_3250"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_214_3250"
          x1="0"
          y1="0"
          x2="36"
          y2="36"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
      </defs>
    </svg>
  );
};
//FILLED RATTING STAR
export const YellowStar = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z"
        fill="url(#paint0_linear_214_2888)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_214_2888"
          x1="0"
          y1="0"
          x2="20"
          y2="20"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2CD75" />
          <stop offset="1" stopColor="#A97424" />
        </linearGradient>
      </defs>
    </svg>
  );
};
//UNFILLED RATTING STAR
export const StarGrey = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z"
        fill="white"
      />
    </svg>
  );
};
//MENU BAR ICON
export const MenuIconBlack = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 7H27.9166M5 16.1666H27.9166M5 25.3333H27.9166"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
// CROSS ICON
export const CrossIcon = () => {
  return (
    <svg
      width="25"
      height="50"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.6667 26.6667L5.33334 5.33337M26.6667 5.33337L5.33334 26.6667"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
// HEADER NOTIFICATION ICON
export const BellIcon = () => {
  return (
    <svg
      className="cursor-pointer notification_hover_animation"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.42895 2.91283C6.55502 2.76235 6.61707 2.56845 6.60178 2.37273C6.58649 2.17702 6.49508 1.99511 6.34716 1.86604C6.19924 1.73697 6.00662 1.67105 5.81064 1.68241C5.61466 1.69378 5.43095 1.78153 5.29895 1.92683L4.00695 3.40683C3.27433 4.24639 2.86018 5.3168 2.83695 6.43083L2.77995 9.14983C2.77791 9.24832 2.79529 9.34625 2.8311 9.43802C2.86691 9.52979 2.92045 9.61361 2.98866 9.6847C3.05686 9.75578 3.1384 9.81273 3.22861 9.8523C3.31883 9.89188 3.41595 9.91329 3.51445 9.91533C3.61294 9.91736 3.71086 9.89998 3.80264 9.86417C3.89441 9.82836 3.97823 9.77482 4.04932 9.70662C4.1204 9.63841 4.17735 9.55687 4.21692 9.46666C4.25649 9.37644 4.27791 9.27932 4.27995 9.18083L4.33595 6.46283C4.35199 5.70055 4.63552 4.96819 5.13695 4.39383L6.42895 2.91283Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.23695 8.2C6.30411 7.13014 6.77647 6.12608 7.55787 5.39224C8.33928 4.65839 9.37098 4.24993 10.4429 4.25H10.9999V3.5C10.9999 3.23478 11.1053 2.98043 11.2928 2.79289C11.4804 2.60536 11.7347 2.5 11.9999 2.5C12.2652 2.5 12.5195 2.60536 12.7071 2.79289C12.8946 2.98043 12.9999 3.23478 12.9999 3.5V4.25H13.5569C14.6289 4.24993 15.6606 4.65839 16.442 5.39224C17.2234 6.12608 17.6958 7.13014 17.7629 8.2L17.9839 11.734C18.0682 13.0815 18.5206 14.38 19.2919 15.488C19.4513 15.7171 19.5487 15.9835 19.5746 16.2613C19.6005 16.5392 19.5541 16.819 19.4398 17.0736C19.3256 17.3281 19.1474 17.5488 18.9226 17.7142C18.6978 17.8795 18.434 17.9838 18.1569 18.017L14.7499 18.425V19.5C14.7499 20.2293 14.4602 20.9288 13.9445 21.4445C13.4288 21.9603 12.7293 22.25 11.9999 22.25C11.2706 22.25 10.5711 21.9603 10.0554 21.4445C9.53968 20.9288 9.24995 20.2293 9.24995 19.5V18.425L5.84295 18.016C5.56604 17.9827 5.30246 17.8784 5.0778 17.7131C4.85313 17.5478 4.67503 17.3273 4.5608 17.0729C4.44657 16.8184 4.40009 16.5388 4.42587 16.2611C4.45165 15.9834 4.54883 15.7171 4.70795 15.488C5.47925 14.3799 5.93168 13.0814 6.01595 11.734L6.23695 8.201V8.2ZM10.4429 5.75C9.75252 5.74992 9.08802 6.01297 8.58473 6.48561C8.08144 6.95825 7.7772 7.60493 7.73395 8.294L7.51395 11.828C7.41229 13.449 6.86787 15.011 5.93995 16.344C5.92842 16.3606 5.92137 16.3798 5.91949 16.3999C5.9176 16.42 5.92095 16.4403 5.9292 16.4587C5.93746 16.4771 5.95034 16.4931 5.96659 16.505C5.98284 16.517 6.00191 16.5246 6.02195 16.527L9.75895 16.976C11.2479 17.154 12.7519 17.154 14.2409 16.976L17.978 16.527C17.998 16.5246 18.0171 16.517 18.0333 16.505C18.0496 16.4931 18.0624 16.4771 18.0707 16.4587C18.0789 16.4403 18.0823 16.42 18.0804 16.3999C18.0785 16.3798 18.0715 16.3606 18.0599 16.344C17.1323 15.0109 16.5883 13.4489 16.4869 11.828L16.266 8.294C16.2227 7.60493 15.9185 6.95825 15.4152 6.48561C14.9119 6.01297 14.2474 5.74992 13.5569 5.75H10.4429ZM11.9999 20.75C11.3099 20.75 10.7499 20.19 10.7499 19.5V18.75H13.2499V19.5C13.2499 20.19 12.6899 20.75 11.9999 20.75Z"
        fill="white"
      />
      <path
        d="M17.643 1.8552C17.4932 1.98597 17.4015 2.17089 17.388 2.36929C17.3745 2.56769 17.4403 2.76333 17.571 2.9132L18.863 4.3932C19.3643 4.96796 19.6475 5.70071 19.663 6.4632L19.72 9.1802C19.7241 9.37911 19.8071 9.56824 19.9506 9.70599C20.0942 9.84374 20.2866 9.91881 20.4855 9.9147C20.6844 9.91059 20.8736 9.82763 21.0113 9.68407C21.1491 9.54051 21.2241 9.34811 21.22 9.1492L21.163 6.4312C21.1398 5.31717 20.7256 4.24677 19.993 3.4072L18.701 1.9272C18.5702 1.77739 18.3853 1.68564 18.1869 1.67214C17.9885 1.65864 17.7929 1.72449 17.643 1.8552Z"
        fill="white"
      />
    </svg>
  );
};

//UP THUNB ICON
export const LikeIcon = ({ isliked }) => {
  return (
    <svg
      className="cursor-pointer"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00008 4.66668L7.50675 4.58468C7.49484 4.65631 7.49867 4.72967 7.51799 4.79966C7.5373 4.86965 7.57162 4.9346 7.61857 4.98999C7.66552 5.04537 7.72396 5.08987 7.78985 5.12038C7.85573 5.1509 7.92747 5.1667 8.00008 5.16668V4.66668ZM0.666748 4.66668V4.16668C0.53414 4.16668 0.406963 4.21936 0.313195 4.31313C0.219426 4.4069 0.166748 4.53407 0.166748 4.66668H0.666748ZM2.00008 11.8333H9.57342V10.8333H2.00008V11.8333ZM10.3734 4.16668H8.00008V5.16668H10.3734V4.16668ZM8.49341 4.74868L9.03075 1.52535L8.04408 1.36068L7.50675 4.58468L8.49341 4.74868ZM7.88008 0.166682H7.73741V1.16668H7.87942L7.88008 0.166682ZM5.65675 1.28002L3.98008 3.79535L4.81208 4.35002L6.48875 1.83468L5.65675 1.28002ZM3.28675 4.16668H0.666748V5.16668H3.28675V4.16668ZM0.166748 4.66668V10H1.16675V4.66668H0.166748ZM11.3714 10.36L12.1714 6.36002L11.1914 6.16335L10.3914 10.1633L11.3714 10.3593V10.36ZM3.98008 3.79535C3.90401 3.90954 3.80093 4.00251 3.67998 4.06729C3.55903 4.13207 3.42395 4.16598 3.28675 4.16602V5.16602C3.90008 5.16602 4.47208 4.86002 4.81208 4.35002L3.98008 3.79535ZM9.03075 1.52535C9.05853 1.35826 9.04959 1.18646 9.00456 1.02318C8.95953 0.859892 8.87948 0.708371 8.76998 0.579143C8.66048 0.449914 8.52416 0.346078 8.37048 0.274851C8.21681 0.203623 8.04946 0.166712 7.88008 0.166682L7.87942 1.16668C7.90358 1.16674 7.92811 1.17206 7.95002 1.18225C7.97192 1.19245 7.99135 1.2073 8.00695 1.22575C8.02255 1.2442 8.03395 1.26583 8.04037 1.28913C8.04678 1.31243 8.04804 1.33684 8.04408 1.36068L9.03075 1.52535ZM10.3734 5.16602C10.9001 5.16602 11.2934 5.64735 11.1907 6.16268L12.1714 6.35935C12.2245 6.09341 12.2179 5.81835 12.1521 5.55527C12.0863 5.29219 11.963 5.04699 11.791 4.83732C11.619 4.62765 11.4027 4.45875 11.1575 4.34278C10.9124 4.22681 10.6446 4.16667 10.3734 4.16668V5.16668V5.16602ZM9.57342 11.8333C9.99722 11.8334 10.408 11.686 10.7358 11.4174C11.0636 11.1488 11.2882 10.7749 11.3714 10.3593L10.3914 10.1627C10.3536 10.3517 10.2514 10.5219 10.1023 10.644C9.95313 10.7662 9.76622 10.8335 9.57342 10.8333V11.8333ZM7.73741 0.166682C7.32586 0.166712 6.92067 0.267679 6.55783 0.461896C6.19498 0.656112 5.88569 0.936904 5.65741 1.27935L6.48875 1.83468C6.62578 1.62912 6.81146 1.45992 7.02929 1.34339C7.24712 1.22685 7.49037 1.16659 7.73741 1.16668V0.166682ZM2.00008 10.8333C1.54008 10.8333 1.16675 10.46 1.16675 10H0.166748C0.166748 10.4862 0.359902 10.9526 0.703719 11.2964C1.04754 11.6402 1.51385 11.8333 2.00008 11.8333V10.8333Z"
        fill={isliked ? "#007bff" : "white"}
      />
      <path
        d="M3.3335 4.6665V11.3332"
        stroke={isliked ? "#007bff" : "white"}
        strokeWidth="1.5"
      />
    </svg>
  );
};
//DOWN THUMB ICON
export const DisLikeIcon = ({ disliked }) => {
  return (
    <svg
      className="cursor-pointer "
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.99967 9.33332L6.49301 9.41532C6.50492 9.34369 6.50108 9.27033 6.48177 9.20034C6.46246 9.13035 6.42814 9.0654 6.38119 9.01001C6.33424 8.95463 6.27579 8.91013 6.20991 8.87961C6.14402 8.8491 6.07228 8.8333 5.99967 8.83332L5.99967 9.33332ZM13.333 9.33332L13.333 9.83332C13.4656 9.83332 13.5928 9.78064 13.6866 9.68687C13.7803 9.5931 13.833 9.46593 13.833 9.33332L13.333 9.33332ZM11.9997 2.16665L4.42634 2.16665L4.42634 3.16665L11.9997 3.16665L11.9997 2.16665ZM3.62634 9.83332L5.99967 9.83332L5.99967 8.83332L3.62634 8.83332L3.62634 9.83332ZM5.50634 9.25132L4.96901 12.4747L5.95567 12.6393L6.49301 9.41532L5.50634 9.25132ZM6.11967 13.8333L6.26234 13.8333L6.26234 12.8333L6.12034 12.8333L6.11967 13.8333ZM8.34301 12.72L10.0197 10.2047L9.18767 9.64998L7.51101 12.1653L8.34301 12.72ZM10.713 9.83332L13.333 9.83332L13.333 8.83332L10.713 8.83332L10.713 9.83332ZM13.833 9.33332L13.833 3.99998L12.833 3.99998L12.833 9.33332L13.833 9.33332ZM2.62834 3.63998L1.82834 7.63998L2.80834 7.83665L3.60834 3.83665L2.62834 3.64065L2.62834 3.63998ZM10.0197 10.2047C10.0957 10.0905 10.1988 9.99749 10.3198 9.93271C10.4407 9.86793 10.5758 9.83402 10.713 9.83398L10.713 8.83398C10.0997 8.83398 9.52767 9.13998 9.18767 9.64998L10.0197 10.2047ZM4.96901 12.4747C4.94123 12.6417 4.95017 12.8135 4.9952 12.9768C5.04023 13.1401 5.12028 13.2916 5.22977 13.4209C5.33927 13.5501 5.4756 13.6539 5.62927 13.7251C5.78295 13.7964 5.95029 13.8333 6.11967 13.8333L6.12034 12.8333C6.09618 12.8333 6.07165 12.8279 6.04974 12.8177C6.02783 12.8075 6.0084 12.7927 5.9928 12.7742C5.9772 12.7558 5.9658 12.7342 5.95939 12.7109C5.95298 12.6876 5.95171 12.6632 5.95567 12.6393L4.96901 12.4747ZM3.62634 8.83398C3.09967 8.83398 2.70634 8.35265 2.80901 7.83732L1.82834 7.64065C1.77529 7.90659 1.78189 8.18165 1.84768 8.44473C1.91346 8.7078 2.03679 8.95301 2.20877 9.16268C2.38075 9.37235 2.5971 9.54125 2.84223 9.65722C3.08736 9.77319 3.35516 9.83333 3.62634 9.83332L3.62634 8.83332L3.62634 8.83398ZM4.42634 2.16665C4.00254 2.16657 3.59179 2.31398 3.26399 2.5826C2.93618 2.85121 2.71156 3.2251 2.62834 3.64065L3.60834 3.83732C3.64613 3.64825 3.74831 3.47814 3.89747 3.35597C4.04663 3.23379 4.23354 3.16646 4.42634 3.16665L4.42634 2.16665ZM6.26234 13.8333C6.6739 13.8333 7.07908 13.7323 7.44193 13.5381C7.80478 13.3439 8.11406 13.0631 8.34234 12.7207L7.51101 12.1653C7.37398 12.3709 7.1883 12.5401 6.97047 12.6566C6.75263 12.7731 6.50939 12.8334 6.26234 12.8333L6.26234 13.8333ZM11.9997 3.16665C12.4597 3.16665 12.833 3.53998 12.833 3.99998L13.833 3.99998C13.833 3.51375 13.6399 3.04744 13.296 2.70362C12.9522 2.35981 12.4859 2.16665 11.9997 2.16665L11.9997 3.16665Z"
        fill={disliked ? "#007bff" : "white"}
      />
      <path
        d="M10.666 9.3335L10.666 2.66683"
        stroke={disliked ? "#007bff" : "white"}
        strokeWidth="1.5"
      />
    </svg>
  );
};

//SHARE ICON
export const ShareIcon = () => {
  return (
    <svg
      className="cursor-pointer"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.471 7.52853L9.13767 2.19519C9.04444 2.10198 8.92566 2.03851 8.79636 2.0128C8.66706 1.98709 8.53304 2.00029 8.41124 2.05074C8.28944 2.10119 8.18533 2.18661 8.11207 2.29622C8.03882 2.40583 7.9997 2.53469 7.99967 2.66652V5.02986C6.17854 5.19839 4.48583 6.04043 3.2528 7.39121C2.01978 8.74199 1.33519 10.5043 1.33301 12.3332V13.3332C1.33311 13.4716 1.37628 13.6065 1.45652 13.7192C1.53677 13.832 1.65011 13.917 1.78082 13.9624C1.91154 14.0078 2.05316 14.0115 2.18603 13.9728C2.3189 13.9341 2.43644 13.855 2.52234 13.7465C3.17547 12.9698 3.97685 12.3311 4.87964 11.8676C5.78243 11.4041 6.76854 11.1252 7.78034 11.0472C7.81367 11.0432 7.89701 11.0365 7.99967 11.0299V13.3332C7.9997 13.465 8.03882 13.5939 8.11207 13.7035C8.18533 13.8131 8.28944 13.8985 8.41124 13.949C8.53304 13.9994 8.66706 14.0126 8.79636 13.9869C8.92566 13.9612 9.04444 13.8977 9.13767 13.8045L14.471 8.47119C14.596 8.34617 14.6662 8.17663 14.6662 7.99986C14.6662 7.82308 14.596 7.65354 14.471 7.52853ZM9.33301 11.7239V10.3332C9.33301 10.1564 9.26277 9.98681 9.13775 9.86179C9.01272 9.73676 8.84315 9.66652 8.66634 9.66652C8.49634 9.66652 7.80234 9.69986 7.62501 9.72319C5.82825 9.88874 4.11795 10.5714 2.70101 11.6885C2.86184 10.2181 3.55937 8.85876 4.66004 7.87063C5.76072 6.88251 7.18719 6.33509 8.66634 6.33319C8.84315 6.33319 9.01272 6.26295 9.13775 6.13793C9.26277 6.0129 9.33301 5.84334 9.33301 5.66652V4.27586L13.057 7.99986L9.33301 11.7239Z"
        fill="white"
      />
    </svg>
  );
};
//DOWNLOAN ICON
export const DownloadIcon = () => {
  return (
    <svg
      className="cursor-pointer"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.00033 13.3337C3.63366 13.3337 3.31966 13.203 3.05833 12.9417C2.79699 12.6803 2.66655 12.3665 2.66699 12.0003V10.0003H4.00033V12.0003H12.0003V10.0003H13.3337V12.0003C13.3337 12.367 13.203 12.681 12.9417 12.9423C12.6803 13.2037 12.3665 13.3341 12.0003 13.3337H4.00033ZM8.00033 10.667L4.66699 7.33366L5.60033 6.36699L7.33366 8.10033V2.66699H8.66699V8.10033L10.4003 6.36699L11.3337 7.33366L8.00033 10.667Z"
        fill="white"
      />
    </svg>
  );
};

//COMMENT BOX ICON
export const CommentBoxIcon = () => {
  return (
    <svg
      className="cursor-pointer"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5C1 4.33696 1.26339 3.70107 1.73223 3.23223C2.20107 2.76339 2.83696 2.5 3.5 2.5H12.5C13.163 2.5 13.7989 2.76339 14.2678 3.23223C14.7366 3.70107 15 4.33696 15 5V10C15 10.3283 14.9353 10.6534 14.8097 10.9567C14.6841 11.26 14.4999 11.5356 14.2678 11.7678C14.0356 11.9999 13.76 12.1841 13.4567 12.3097C13.1534 12.4353 12.8283 12.5 12.5 12.5H8.688L5.625 15.18C5.48327 15.3039 5.30885 15.3844 5.12261 15.4118C4.93636 15.4391 4.74617 15.4123 4.57476 15.3345C4.40336 15.2566 4.25801 15.1311 4.15608 14.9728C4.05415 14.8145 3.99996 14.6303 4 14.442V12.5H3.5C2.83696 12.5 2.20107 12.2366 1.73223 11.7678C1.26339 11.2989 1 10.663 1 10V5ZM3.5 3.5C3.10218 3.5 2.72064 3.65804 2.43934 3.93934C2.15804 4.22064 2 4.60218 2 5V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10218 11.5 3.5 11.5H5V14.398L8.312 11.5H12.5C12.8978 11.5 13.2794 11.342 13.5607 11.0607C13.842 10.7794 14 10.3978 14 10V5C14 4.60218 13.842 4.22064 13.5607 3.93934C13.2794 3.65804 12.8978 3.5 12.5 3.5H3.5Z"
        fill="white"
      />
    </svg>
  );
};

//SORT FILTER ICON
export const SortIcon = () => {
  return (
    <svg
      className="cursor-pointer"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="100"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 7C1.25 6.80109 1.32902 6.61032 1.46967 6.46967C1.61032 6.32902 1.80109 6.25 2 6.25H10C10.1989 6.25 10.3897 6.32902 10.5303 6.46967C10.671 6.61032 10.75 6.80109 10.75 7C10.75 7.19891 10.671 7.38968 10.5303 7.53033C10.3897 7.67098 10.1989 7.75 10 7.75H2C1.80109 7.75 1.61032 7.67098 1.46967 7.53033C1.32902 7.38968 1.25 7.19891 1.25 7ZM17 7.75C16.4419 7.75 15.8892 7.85993 15.3736 8.07351C14.858 8.28709 14.3894 8.60015 13.9948 8.9948C13.6001 9.38944 13.2871 9.85796 13.0735 10.3736C12.8599 10.8892 12.75 11.4419 12.75 12C12.75 12.5581 12.8599 13.1108 13.0735 13.6264C13.2871 14.142 13.6001 14.6106 13.9948 15.0052C14.3894 15.3999 14.858 15.7129 15.3736 15.9265C15.8892 16.1401 16.4419 16.25 17 16.25C18.1272 16.25 19.2082 15.8022 20.0052 15.0052C20.8022 14.2082 21.25 13.1272 21.25 12C21.25 10.8728 20.8022 9.79183 20.0052 8.9948C19.2082 8.19777 18.1272 7.75 17 7.75ZM11.25 12C11.25 11.2449 11.3987 10.4972 11.6877 9.79957C11.9767 9.10195 12.4002 8.46807 12.9341 7.93414C13.4681 7.4002 14.1019 6.97666 14.7996 6.68769C15.4972 6.39873 16.2449 6.25 17 6.25C17.7551 6.25 18.5028 6.39873 19.2004 6.68769C19.8981 6.97666 20.5319 7.4002 21.0659 7.93414C21.5998 8.46807 22.0233 9.10195 22.3123 9.79957C22.6013 10.4972 22.75 11.2449 22.75 12C22.75 13.525 22.1442 14.9875 21.0659 16.0659C19.9875 17.1442 18.525 17.75 17 17.75C15.475 17.75 14.0125 17.1442 12.9341 16.0659C11.8558 14.9875 11.25 13.525 11.25 12ZM17 9.25C17.1989 9.25 17.3897 9.32902 17.5303 9.46967C17.671 9.61032 17.75 9.80109 17.75 10V11.566L18.567 12.509C18.6315 12.5835 18.6807 12.6699 18.7117 12.7634C18.7428 12.8568 18.7552 12.9555 18.7481 13.0537C18.7411 13.152 18.7147 13.2479 18.6706 13.3359C18.6265 13.424 18.5655 13.5025 18.491 13.567C18.4165 13.6315 18.3301 13.6807 18.2366 13.7117C18.1432 13.7428 18.0445 13.7552 17.9463 13.7481C17.848 13.7411 17.7521 13.7147 17.6641 13.6706C17.576 13.6265 17.4975 13.5655 17.433 13.491L16.433 12.337C16.3152 12.2009 16.2502 12.027 16.25 11.847V10C16.25 9.80109 16.329 9.61032 16.4697 9.46967C16.6103 9.32902 16.8011 9.25 17 9.25ZM1.25 12C1.25 11.8011 1.32902 11.6103 1.46967 11.4697C1.61032 11.329 1.80109 11.25 2 11.25H8C8.19891 11.25 8.38968 11.329 8.53033 11.4697C8.67098 11.6103 8.75 11.8011 8.75 12C8.75 12.1989 8.67098 12.3897 8.53033 12.5303C8.38968 12.671 8.19891 12.75 8 12.75H2C1.80109 12.75 1.61032 12.671 1.46967 12.5303C1.32902 12.3897 1.25 12.1989 1.25 12ZM1.25 17C1.25 16.8011 1.32902 16.6103 1.46967 16.4697C1.61032 16.329 1.80109 16.25 2 16.25H10C10.1989 16.25 10.3897 16.329 10.5303 16.4697C10.671 16.6103 10.75 16.8011 10.75 17C10.75 17.1989 10.671 17.3897 10.5303 17.5303C10.3897 17.671 10.1989 17.75 10 17.75H2C1.80109 17.75 1.61032 17.671 1.46967 17.5303C1.32902 17.3897 1.25 17.1989 1.25 17Z"
        fill="white"
      />
    </svg>
  );
};

//PROFILE ICON FOR THOSE USER WHO ADD COMMENTS
export const CommentBoxProfileIcon = () => {
  return (
    <svg
      className="cursor-pointer"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.9">
        <path
          d="M15 2.5C13.3585 2.5 11.733 2.82332 10.2165 3.45151C8.69989 4.07969 7.3219 5.00043 6.16117 6.16117C3.81696 8.50537 2.5 11.6848 2.5 15C2.5 18.3152 3.81696 21.4946 6.16117 23.8388C7.3219 24.9996 8.69989 25.9203 10.2165 26.5485C11.733 27.1767 13.3585 27.5 15 27.5C18.3152 27.5 21.4946 26.183 23.8388 23.8388C26.183 21.4946 27.5 18.3152 27.5 15C27.5 13.3585 27.1767 11.733 26.5485 10.2165C25.9203 8.69989 24.9996 7.3219 23.8388 6.16117C22.6781 5.00043 21.3001 4.07969 19.7835 3.45151C18.267 2.82332 16.6415 2.5 15 2.5ZM8.8375 22.85C9.375 21.725 12.65 20.625 15 20.625C17.35 20.625 20.625 21.725 21.1625 22.85C19.4117 24.245 17.2386 25.0032 15 25C12.675 25 10.5375 24.2 8.8375 22.85ZM22.95 21.0375C21.1625 18.8625 16.825 18.125 15 18.125C13.175 18.125 8.8375 18.8625 7.05 21.0375C5.72023 19.3058 4.99958 17.1834 5 15C5 9.4875 9.4875 5 15 5C20.5125 5 25 9.4875 25 15C25 17.275 24.225 19.375 22.95 21.0375ZM15 7.5C12.575 7.5 10.625 9.45 10.625 11.875C10.625 14.3 12.575 16.25 15 16.25C17.425 16.25 19.375 14.3 19.375 11.875C19.375 9.45 17.425 7.5 15 7.5ZM15 13.75C14.5027 13.75 14.0258 13.5525 13.6742 13.2008C13.3225 12.8492 13.125 12.3723 13.125 11.875C13.125 11.3777 13.3225 10.9008 13.6742 10.5492C14.0258 10.1975 14.5027 10 15 10C15.4973 10 15.9742 10.1975 16.3258 10.5492C16.6775 10.9008 16.875 11.3777 16.875 11.875C16.875 12.3723 16.6775 12.8492 16.3258 13.2008C15.9742 13.5525 15.4973 13.75 15 13.75Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

// HOME ICON IN ACCOUNT PAGE
export const HomeIcon = () => {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.00033 2.24167L13.167 5.99167V12.5H11.5003V7.5H6.50033V12.5H4.83366V5.99167L9.00033 2.24167ZM9.00033 0L0.666992 7.5H3.16699V14.1667H8.16699V9.16667H9.83366V14.1667H14.8337V7.5H17.3337L9.00033 0Z"
        fill="white"
      />
    </svg>
  );
};
//ICON FOR MUSIC LIBRARY
export const LibrayIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 12.3919L8.86667 11.3336C7.55627 10.1179 5.92544 9.30249 4.16667 8.98357V14.7752C6.34167 15.0586 8.33333 15.8919 10 17.1252C11.6667 15.8919 13.6583 15.0586 15.8333 14.7752V8.98357C14.0333 9.30857 12.425 10.1419 11.1333 11.3336M15.8333 7.2919C16.375 7.20857 16.9333 7.1669 17.5 7.1669V16.3336C14.5833 16.3336 11.9667 17.4586 10 19.2836C8.03333 17.4586 5.41667 16.3336 2.5 16.3336V7.1669C3.06667 7.1669 3.625 7.20857 4.16667 7.2919C6.40833 7.63357 8.41667 8.65024 10 10.1169C11.5833 8.65024 13.5917 7.63357 15.8333 7.2919ZM10 5.50023C10.225 5.50023 10.4167 5.4169 10.5917 5.25857C10.75 5.08357 10.8333 4.8919 10.8333 4.6669C10.8333 4.4419 10.75 4.25023 10.5917 4.07523C10.4167 3.92523 10.225 3.83357 10 3.83357C9.775 3.83357 9.58333 3.92523 9.40833 4.07523C9.25833 4.25023 9.16667 4.45023 9.16667 4.6669C9.16667 4.88357 9.25833 5.08357 9.40833 5.25857C9.58333 5.4169 9.78333 5.50023 10 5.50023ZM11.7667 6.43357C11.2981 6.90212 10.6626 7.16535 10 7.16535C9.33737 7.16535 8.70188 6.90212 8.23333 6.43357C7.76478 5.96502 7.50156 5.32953 7.50156 4.6669C7.50156 4.00427 7.76478 3.36878 8.23333 2.90023C8.46534 2.66823 8.74076 2.4842 9.04389 2.35864C9.34701 2.23308 9.6719 2.16846 10 2.16846C10.3281 2.16846 10.653 2.23308 10.9561 2.35864C11.2592 2.4842 11.5347 2.66823 11.7667 2.90023C11.9987 3.13224 12.1827 3.40766 12.3083 3.71079C12.4338 4.01391 12.4984 4.3388 12.4984 4.6669C12.4984 4.995 12.4338 5.31989 12.3083 5.62301C12.1827 5.92614 11.9987 6.20157 11.7667 6.43357Z"
        fill="white"
      />
    </svg>
  );
};
//REVIEW ICON
export const MyReviewIcon = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.56282 10.3753L9.00032 8.89616L11.4378 10.3753L10.792 7.60449L12.9587 5.72949L10.1045 5.50033L9.00032 2.87533L7.89616 5.50033L5.04199 5.72949L7.20866 7.60449L6.56282 10.3753ZM0.666992 16.8337V1.83366C0.666992 1.37533 0.830326 0.982827 1.15699 0.65616C1.48366 0.329493 1.87588 0.166438 2.33366 0.166994H15.667C16.1253 0.166994 16.5178 0.330327 16.8445 0.656994C17.1712 0.98366 17.3342 1.37588 17.3337 1.83366V11.8337C17.3337 12.292 17.1703 12.6845 16.8437 13.0112C16.517 13.3378 16.1248 13.5009 15.667 13.5003H4.00032L0.666992 16.8337ZM3.29199 11.8337H15.667V1.83366H2.33366V12.7712L3.29199 11.8337Z"
        fill="white"
      />
    </svg>
  );
};

//HISTORY ICON
export const HistoryIcon = () => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 15C6.08333 15 4.41306 14.3644 2.98917 13.0933C1.56528 11.8222 0.749444 10.2356 0.541667 8.33333H2.25C2.44444 9.77778 3.08694 10.9722 4.1775 11.9167C5.26806 12.8611 6.54222 13.3333 8 13.3333C9.625 13.3333 11.0036 12.7672 12.1358 11.635C13.2681 10.5028 13.8339 9.12444 13.8333 7.5C13.8333 5.875 13.2672 4.49639 12.135 3.36417C11.0028 2.23194 9.62444 1.66611 8 1.66667C7.04167 1.66667 6.14583 1.88889 5.3125 2.33333C4.47917 2.77778 3.77778 3.38889 3.20833 4.16667H5.5V5.83333H0.5V0.833333H2.16667V2.79167C2.875 1.90278 3.73972 1.21528 4.76083 0.729167C5.78194 0.243056 6.86167 0 8 0C9.04167 0 10.0175 0.198056 10.9275 0.594167C11.8375 0.990278 12.6292 1.52472 13.3025 2.1975C13.9758 2.87139 14.5106 3.66306 14.9067 4.5725C15.3028 5.48195 15.5006 6.45778 15.5 7.5C15.5 8.54167 15.3019 9.5175 14.9058 10.4275C14.5097 11.3375 13.9753 12.1292 13.3025 12.8025C12.6286 13.4758 11.8369 14.0106 10.9275 14.4067C10.0181 14.8028 9.04222 15.0006 8 15ZM10.3333 11L7.16667 7.83333V3.33333H8.83333V7.16667L11.5 9.83333L10.3333 11Z"
        fill="white"
      />
    </svg>
  );
};
//SUBSCRIPTION ICON
export const SubscriptionIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33366 18.8337C2.87533 18.8337 2.48283 18.6703 2.15616 18.3437C1.82949 18.017 1.66644 17.6248 1.66699 17.167V8.83366C1.66699 8.37533 1.83033 7.98283 2.15699 7.65616C2.48366 7.32949 2.87588 7.16644 3.33366 7.16699H16.667C17.1253 7.16699 17.5178 7.33033 17.8445 7.65699C18.1712 7.98366 18.3342 8.37588 18.3337 8.83366V17.167C18.3337 17.6253 18.1703 18.0178 17.8437 18.3445C17.517 18.6712 17.1248 18.8342 16.667 18.8337H3.33366ZM3.33366 17.167H16.667V8.83366H3.33366V17.167ZM8.33366 16.3337L13.3337 13.0003L8.33366 9.66699V16.3337ZM3.33366 6.33366V4.66699H16.667V6.33366H3.33366ZM5.83366 3.83366V2.16699H14.167V3.83366H5.83366Z"
        fill="white"
      />
    </svg>
  );
};
//TRANDING VIDEO ICON
export const TrendingIcon = () => {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.78585 1.25706C7.69948 1.20547 7.60075 1.17822 7.50014 1.17822C7.39953 1.17822 7.3008 1.20547 7.21442 1.25706C7.14318 1.31351 7.09511 1.39412 7.07931 1.48364C7.06351 1.57315 7.08109 1.66535 7.12871 1.74278C8.88585 4.78563 9.25728 8.92849 6.85728 11.2142C5.93389 10.4382 5.20081 9.46079 4.71442 8.35706C3.82689 8.84999 3.09135 9.57663 2.58766 10.4581C2.08397 11.3396 1.83137 12.3422 1.85728 13.3571C1.89351 14.2517 2.10833 15.1301 2.4891 15.9406C2.86986 16.751 3.40889 17.4771 4.07445 18.0761C4.74001 18.6751 5.51866 19.1349 6.36457 19.4285C7.21049 19.7221 8.10659 19.8435 9.00014 19.7856C13.6001 19.7856 15.9859 16.9285 16.143 13.3571C16.3287 9.07135 13.2859 3.79992 7.78585 1.25706Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

//MY ACCOUNT ICON
export const MyAccountIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.99967 0.833008C7.88373 0.833008 8.73158 1.1842 9.3567 1.80932C9.98182 2.43444 10.333 3.28229 10.333 4.16634C10.333 5.0504 9.98182 5.89824 9.3567 6.52336C8.73158 7.14848 7.88373 7.49967 6.99967 7.49967C6.11562 7.49967 5.26777 7.14848 4.64265 6.52336C4.01753 5.89824 3.66634 5.0504 3.66634 4.16634C3.66634 3.28229 4.01753 2.43444 4.64265 1.80932C5.26777 1.1842 6.11562 0.833008 6.99967 0.833008ZM6.99967 2.49967C6.55765 2.49967 6.13372 2.67527 5.82116 2.98783C5.5086 3.30039 5.33301 3.72431 5.33301 4.16634C5.33301 4.60837 5.5086 5.03229 5.82116 5.34485C6.13372 5.65741 6.55765 5.83301 6.99967 5.83301C7.4417 5.83301 7.86562 5.65741 8.17818 5.34485C8.49075 5.03229 8.66634 4.60837 8.66634 4.16634C8.66634 3.72431 8.49075 3.30039 8.17818 2.98783C7.86562 2.67527 7.4417 2.49967 6.99967 2.49967ZM6.99967 8.33301C9.22467 8.33301 13.6663 9.44134 13.6663 11.6663V14.1663H0.333008V11.6663C0.333008 9.44134 4.77467 8.33301 6.99967 8.33301ZM6.99967 9.91634C4.52467 9.91634 1.91634 11.133 1.91634 11.6663V12.583H12.083V11.6663C12.083 11.133 9.47467 9.91634 6.99967 9.91634Z"
        fill="white"
      />
    </svg>
  );
};

//MY FRIENDS ICON
export const MyFriendsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M8.75 3.75C8.75 3.02065 8.46027 2.32118 7.94454 1.80546C7.42882 1.28973 6.72935 1 6 1C5.27065 1 4.57118 1.28973 4.05546 1.80546C3.53973 2.32118 3.25 3.02065 3.25 3.75C3.25 4.47935 3.53973 5.17882 4.05546 5.69454C4.57118 6.21027 5.27065 6.5 6 6.5C6.72935 6.5 7.42882 6.21027 7.94454 5.69454C8.46027 5.17882 8.75 4.47935 8.75 3.75ZM4.25 3.75C4.25 3.52019 4.29526 3.29262 4.38321 3.0803C4.47116 2.86798 4.60006 2.67507 4.76256 2.51256C4.92507 2.35006 5.11798 2.22116 5.3303 2.13321C5.54262 2.04527 5.77019 2 6 2C6.22981 2 6.45738 2.04527 6.6697 2.13321C6.88202 2.22116 7.07493 2.35006 7.23744 2.51256C7.39994 2.67507 7.52884 2.86798 7.61679 3.0803C7.70474 3.29262 7.75 3.52019 7.75 3.75C7.75 4.21413 7.56563 4.65925 7.23744 4.98744C6.90925 5.31563 6.46413 5.5 6 5.5C5.53587 5.5 5.09075 5.31563 4.76256 4.98744C4.43437 4.65925 4.25 4.21413 4.25 3.75ZM2.5 7.5H6.683C6.519 7.81 6.397 8.146 6.325 8.5H2.5C2.36739 8.5 2.24021 8.55268 2.14645 8.64645C2.05268 8.74021 2 8.86739 2 9V9.5C2 10.76 3.099 12.114 5.096 12.43C4.774 12.65 4.506 12.943 4.315 13.284C2.205 12.713 1 11.087 1 9.5V9C1 8.60218 1.15804 8.22064 1.43934 7.93934C1.72064 7.65804 2.10218 7.5 2.5 7.5ZM7.879 7.5C8.383 6.89 9.146 6.5 10 6.5C10.5989 6.49896 11.1816 6.69386 11.6594 7.05497C12.1371 7.41608 12.4836 7.92356 12.646 8.5C12.7907 9.0145 12.7826 9.56 12.6225 10.0699C12.4625 10.5799 12.1574 11.0322 11.7447 11.3717C11.3319 11.7112 10.8292 11.9232 10.298 11.9819C9.76673 12.0405 9.2299 11.9433 8.753 11.702C8.38581 11.5151 8.06531 11.2481 7.81518 10.9207C7.56504 10.5934 7.39166 10.2139 7.30785 9.81055C7.22405 9.40716 7.23195 8.99009 7.33098 8.59017C7.43001 8.19024 7.61664 7.81767 7.879 7.5ZM8.419 8.5C8.32051 8.70775 8.2639 8.93287 8.25241 9.1625C8.24092 9.39212 8.27477 9.62177 8.35203 9.83831C8.42929 10.0549 8.54844 10.2541 8.70269 10.4246C8.85693 10.5951 9.04325 10.7335 9.251 10.832C9.45875 10.9305 9.68387 10.9871 9.9135 10.9986C10.1431 11.0101 10.3728 10.9762 10.5893 10.899C10.8059 10.8217 11.0051 10.7026 11.1756 10.5483C11.3461 10.3941 11.4845 10.2078 11.583 10C11.7819 9.58029 11.806 9.09876 11.6498 8.66133C11.4937 8.22391 11.1702 7.86641 10.7505 7.6675C10.3308 7.46859 9.84926 7.44455 9.41183 7.60067C8.97441 7.7568 8.61791 8.0803 8.419 8.5ZM15.685 13.284C15.4945 12.9428 15.2271 12.6507 14.904 12.431C16.9 12.114 18 10.759 18 9.5V9C18 8.86739 17.9473 8.74021 17.8536 8.64645C17.7598 8.55268 17.6326 8.5 17.5 8.5H13.675C13.6044 8.15133 13.4841 7.81458 13.318 7.5H17.5C17.8978 7.5 18.2794 7.65804 18.5607 7.93934C18.842 8.22064 19 8.60218 19 9V9.5C19 11.087 17.794 12.712 15.685 13.284ZM14.487 13.371C14.2141 13.1314 13.8632 12.9995 13.5 13H6.5C6.30287 12.9995 6.10758 13.0379 5.92535 13.1131C5.74312 13.1883 5.57756 13.2988 5.43816 13.4382C5.29877 13.5776 5.1883 13.7431 5.11311 13.9254C5.03791 14.1076 4.99947 14.3029 5 14.5V15C5 16.971 6.86 19 10 19C13.14 19 15 16.971 15 15V14.5C15 14.05 14.802 13.646 14.487 13.37V13.371ZM6 14.5C6 14.3674 6.05268 14.2402 6.14645 14.1464C6.24021 14.0527 6.36739 14 6.5 14H13.5C13.6326 14 13.7598 14.0527 13.8536 14.1464C13.9473 14.2402 14 14.3674 14 14.5V15C14 16.438 12.568 18 10 18C7.432 18 6 16.438 6 15V14.5ZM14 1C14.7293 1 15.4288 1.28973 15.9445 1.80546C16.4603 2.32118 16.75 3.02065 16.75 3.75C16.75 4.47935 16.4603 5.17882 15.9445 5.69454C15.4288 6.21027 14.7293 6.5 14 6.5C13.2707 6.5 12.5712 6.21027 12.0555 5.69454C11.5397 5.17882 11.25 4.47935 11.25 3.75C11.25 3.02065 11.5397 2.32118 12.0555 1.80546C12.5712 1.28973 13.2707 1 14 1ZM14 2C13.5359 2 13.0908 2.18437 12.7626 2.51256C12.4344 2.84075 12.25 3.28587 12.25 3.75C12.25 4.21413 12.4344 4.65925 12.7626 4.98744C13.0908 5.31563 13.5359 5.5 14 5.5C14.4641 5.5 14.9092 5.31563 15.2374 4.98744C15.5656 4.65925 15.75 4.21413 15.75 3.75C15.75 3.28587 15.5656 2.84075 15.2374 2.51256C14.9092 2.18437 14.4641 2 14 2Z"
        fill="white"
      />
    </svg>
  );
};

//MY COMMUNITIES ICON
export const MyCommunitiesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M2.0625 10C2.0625 7.89484 2.89877 5.87591 4.38734 4.38734C5.87591 2.89877 7.89484 2.0625 10 2.0625C12.1052 2.0625 14.1241 2.89877 15.6127 4.38734C17.1012 5.87591 17.9375 7.89484 17.9375 10C17.9375 12.1052 17.1012 14.1241 15.6127 15.6127C14.1241 17.1012 12.1052 17.9375 10 17.9375C7.89484 17.9375 5.87591 17.1012 4.38734 15.6127C2.89877 14.1241 2.0625 12.1052 2.0625 10ZM9.50391 3.13109C8.83914 3.33349 8.17934 3.94468 7.63165 4.97159C7.4512 5.313 7.29601 5.66717 7.1673 6.03125H9.50391V3.13109ZM6.12055 6.03125C6.28592 5.50422 6.49844 4.99316 6.75555 4.50427C6.9271 4.17988 7.12523 3.87025 7.34788 3.57856C6.11857 4.08838 5.0609 4.93947 4.29988 6.03125H6.12055ZM5.54309 9.50391C5.57286 8.63376 5.68002 7.79933 5.85266 7.02344H3.72342C3.35345 7.80235 3.13269 8.64369 3.07255 9.50391H5.54309ZM6.87163 7.02344C6.67648 7.83684 6.56413 8.66789 6.53627 9.50391H9.50391V7.02344H6.87163ZM10.4961 7.02344V9.50391H13.4627C13.4352 8.66792 13.3232 7.83686 13.1284 7.02344H10.4961ZM6.53727 10.4961C6.56479 11.3321 6.67682 12.1631 6.87163 12.9766H9.50391V10.4961H6.53727ZM10.4961 10.4961V12.9766H13.1284C13.3139 12.2175 13.432 11.3811 13.4637 10.4961H10.4961ZM7.1673 13.9688C7.30423 14.3517 7.46 14.7069 7.63165 15.0284C8.17934 16.0553 8.84013 16.6655 9.50391 16.8689V13.9688H7.1673ZM7.34788 16.4214C7.12521 16.1298 6.92709 15.8201 6.75555 15.4957C6.49845 15.0068 6.28592 14.4958 6.12055 13.9688H4.29988C5.06086 15.0606 6.11854 15.9117 7.34788 16.4214ZM5.85266 12.9766C5.67323 12.161 5.5696 11.3307 5.54309 10.4961H3.07255C3.13406 11.3791 3.36127 12.2156 3.72342 12.9766H5.85266ZM12.6521 16.4214C13.8815 15.9117 14.9391 15.0606 15.7001 13.9688H13.8795C13.7141 14.4958 13.5015 15.0068 13.2445 15.4957C13.0729 15.8201 12.8748 16.1298 12.6521 16.4214ZM10.4961 13.9688V16.8689C11.1609 16.6665 11.8207 16.0553 12.3684 15.0284C12.54 14.7069 12.6958 14.3517 12.8327 13.9688H10.4961ZM14.1473 12.9766H16.2766C16.6387 12.2156 16.8659 11.3791 16.9275 10.4961H14.4569C14.4304 11.3307 14.3268 12.1611 14.1473 12.9766ZM16.9275 9.50391C16.8673 8.64369 16.6465 7.80236 16.2766 7.02344H14.1473C14.32 7.79933 14.4271 8.63376 14.4569 9.50391H16.9275ZM13.2445 4.50427C13.4895 4.96465 13.7028 5.47662 13.8795 6.03125H15.7001C14.9391 4.93943 13.8815 4.08833 12.6521 3.57856C12.8684 3.86034 13.0669 4.17189 13.2445 4.50427ZM12.8327 6.03125C12.704 5.66716 12.5488 5.31299 12.3684 4.97159C11.8207 3.94468 11.1609 3.33448 10.4961 3.13109V6.03125H12.8327Z"
        fill="white"
      />
    </svg>
  );
};

//SIGNOUT ICON
export const SignOutIcon = () => {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 2.9375C0 1.73 0.98 0.75 2.1875 0.75H5.3125C5.56114 0.75 5.7996 0.848772 5.97541 1.02459C6.15123 1.2004 6.25 1.43886 6.25 1.6875C6.25 1.93614 6.15123 2.1746 5.97541 2.35041C5.7996 2.52623 5.56114 2.625 5.3125 2.625H2.1875C2.10462 2.625 2.02513 2.65792 1.96653 2.71653C1.90792 2.77513 1.875 2.85462 1.875 2.9375V16.0625C1.875 16.235 2.015 16.375 2.1875 16.375H5.3125C5.56114 16.375 5.7996 16.4738 5.97541 16.6496C6.15123 16.8254 6.25 17.0639 6.25 17.3125C6.25 17.5611 6.15123 17.7996 5.97541 17.9754C5.7996 18.1512 5.56114 18.25 5.3125 18.25H2.1875C1.60734 18.25 1.05094 18.0195 0.640704 17.6093C0.230468 17.1991 0 16.6427 0 16.0625V2.9375ZM13.05 8.5625L10.5875 6.1C10.4641 5.98541 10.3739 5.83966 10.3264 5.6781C10.2788 5.51654 10.2758 5.34515 10.3175 5.18199C10.3592 5.01884 10.4442 4.86996 10.5634 4.75103C10.6826 4.63211 10.8317 4.54754 10.995 4.50625C11.158 4.46448 11.3292 4.46739 11.4906 4.51469C11.6521 4.56198 11.7978 4.6519 11.9125 4.775L15.975 8.8375C16.1506 9.01328 16.2492 9.25156 16.2492 9.5C16.2492 9.74844 16.1506 9.98672 15.975 10.1625L11.9125 14.225C11.7979 14.3484 11.6522 14.4386 11.4906 14.4861C11.329 14.5337 11.1577 14.5367 10.9945 14.495C10.8313 14.4533 10.6825 14.3683 10.5635 14.2491C10.4446 14.1299 10.36 13.9808 10.3188 13.8175C10.277 13.6545 10.2799 13.4833 10.3272 13.3219C10.3745 13.1604 10.4644 13.0147 10.5875 12.9L13.05 10.4375H5.9375C5.68886 10.4375 5.4504 10.3387 5.27459 10.1629C5.09877 9.9871 5 9.74864 5 9.5C5 9.25136 5.09877 9.0129 5.27459 8.83709C5.4504 8.66127 5.68886 8.5625 5.9375 8.5625H13.05Z"
        fill="white"
      />
    </svg>
  );
};

// MOST RATTED SLIDER ICON
export const MostRatedIcon = () => {
  return (
    <svg
      width="31"
      height="32"
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5504 0.604969C7.58652 1.45263 2.89414 6.26005 2.02227 12.4116C1.88906 13.3501 1.88906 15.0696 2.02227 15.9778C2.25234 17.5641 2.7125 18.9628 3.45117 20.3493L3.7418 20.9003L2.10703 22.529C1.21094 23.4251 0.363281 24.2909 0.236133 24.4483C0.0242187 24.7147 0 24.7813 0 25.0841C0 25.4837 0.145312 25.7682 0.405664 25.9015C0.496484 25.9499 1.41074 26.2647 2.43398 26.6038L4.29277 27.2214L4.91035 29.0802C5.24941 30.1034 5.56426 31.0177 5.6127 31.1085C5.8125 31.5081 6.56328 31.6655 6.93867 31.3809C7.03555 31.3143 8.0709 30.3032 9.2334 29.1407L11.3586 27.0276L12.0488 27.2093C13.3324 27.5362 13.9379 27.6089 15.5 27.6089C17.0621 27.6089 17.6676 27.5362 18.9512 27.2093L19.6414 27.0276L21.7666 29.1407C22.9291 30.3032 23.9645 31.3143 24.0613 31.3809C24.4307 31.6595 25.1936 31.502 25.3934 31.1024C25.4357 31.0116 25.7506 30.1034 26.0896 29.0802L26.7072 27.2214L28.566 26.6038C29.5893 26.2647 30.4975 25.9499 30.5883 25.9075C30.8426 25.7743 31 25.4655 31 25.078C31 24.7813 30.9758 24.7147 30.7639 24.4483C30.6367 24.2909 29.7951 23.4251 28.899 22.535L27.2703 20.9124L27.7002 20.0526C28.6508 18.1515 29.0686 16.3653 29.0746 14.228C29.0807 11.9454 28.6205 10.0382 27.573 7.95536C26.2229 5.28524 24.0311 3.0995 21.4094 1.82196C20.265 1.25887 19.2236 0.919813 17.8613 0.659462C17.1408 0.526258 14.3617 0.489931 13.5504 0.604969ZM17.1893 2.54852C18.1156 2.66962 19.1268 2.93602 20.041 3.30536C23.8131 4.81298 26.3016 8.02196 27.0342 12.3208C27.1916 13.235 27.2219 14.7608 27.1008 15.5903C26.7012 18.321 25.5629 20.5673 23.6072 22.4684C21.4033 24.6058 18.5576 25.7622 15.5 25.7622C12.4605 25.7622 9.61484 24.6118 7.4291 22.4987C5.95781 21.0759 5.02539 19.6046 4.3957 17.7034C3.59648 15.3057 3.63281 12.7507 4.51074 10.1108C4.74082 9.42059 5.37051 8.137 5.78223 7.50731C8.2041 3.83212 12.5635 1.937 17.1893 2.54852ZM5.32207 23.0618C6.15762 24.0427 7.39277 25.0538 8.62793 25.7804C9.02754 26.0165 9.3666 26.2163 9.38477 26.2284C9.40898 26.2526 6.89629 28.7895 6.8418 28.7895C6.82363 28.7895 6.61777 28.2265 6.3877 27.5302C5.90937 26.077 5.80645 25.853 5.57637 25.7138C5.47949 25.6532 4.7832 25.405 4.03242 25.1567L2.66406 24.7026L3.73574 23.6249C4.3291 23.0376 4.82559 22.5532 4.8498 22.5532C4.86797 22.5532 5.07988 22.7833 5.32207 23.0618ZM27.2643 23.6309L28.3359 24.7026L26.9131 25.1809C26.0715 25.4595 25.4176 25.7077 25.3268 25.7864C25.2057 25.8954 25.0604 26.2466 24.6789 27.3849L24.1885 28.8501L22.8867 27.5483C22.1723 26.8339 21.6031 26.2405 21.6152 26.2284C21.6334 26.2163 21.9725 26.0165 22.3721 25.7804C23.6072 25.0538 24.8424 24.0427 25.6779 23.0618C25.9201 22.7833 26.132 22.5532 26.1502 22.5532C26.1744 22.5532 26.6709 23.0376 27.2643 23.6309Z"
        fill="white"
      />
      <path
        d="M14.2286 4.44961C12.721 4.66152 11.1347 5.28516 9.88741 6.16309C9.20323 6.64141 8.06495 7.77969 7.58663 8.46387C5.79444 11.0068 5.35851 14.1553 6.35753 17.2371C7.44132 20.5369 10.0569 22.8256 13.5747 23.534C14.5677 23.7338 16.4325 23.7338 17.4255 23.534C21.361 22.7408 24.1523 19.9738 24.9454 16.0807C25.4237 13.7375 25.1452 11.6305 24.0978 9.60215C22.7657 7.02891 20.3317 5.18223 17.4497 4.56465C16.7776 4.42539 14.9067 4.35879 14.2286 4.44961ZM16.8987 6.42344C19.4296 6.83516 21.5851 8.5002 22.5962 10.8252C23.0866 11.9514 23.3591 13.4227 23.2864 14.5549C23.0866 17.885 20.7374 20.7367 17.486 21.6146C15.1792 22.2383 12.6726 21.7297 10.723 20.2402C8.62804 18.6357 7.42921 15.8445 7.74405 13.3137C8.10128 10.4619 9.5423 8.33066 11.9278 7.12578C13.4173 6.375 15.1368 6.13281 16.8987 6.42344Z"
        fill="white"
      />
      <path
        d="M15.0763 8.36698C14.9128 8.45174 14.6827 8.74842 14.0894 9.62635C13.6655 10.256 13.2901 10.8131 13.2659 10.8555C13.2417 10.8978 12.6362 11.0976 11.9218 11.2914C11.2073 11.4912 10.5534 11.6849 10.4565 11.7213C10.2265 11.8181 10.0024 12.0967 9.954 12.351C9.87529 12.7808 9.96006 12.9383 10.8985 14.1189C11.9399 15.4328 11.8431 15.0877 11.7462 16.9767C11.6917 18.0666 11.6978 18.1695 11.8007 18.4056C11.8673 18.557 11.9944 18.7084 12.1216 18.7871C12.4909 19.0172 12.7573 18.9748 14.1983 18.4299L15.5001 17.9455L16.8079 18.4299C18.2489 18.9687 18.5093 19.0172 18.8786 18.7871C19.0058 18.7084 19.1329 18.557 19.1995 18.4056C19.3024 18.1695 19.3085 18.0666 19.254 16.9767C19.1571 15.0877 19.0603 15.4328 20.1017 14.1189C20.7313 13.3258 21.0159 12.9201 21.0462 12.7748C21.137 12.2844 20.9009 11.8545 20.4468 11.691C20.3075 11.6365 19.6536 11.4488 18.9876 11.2672C18.3276 11.0855 17.7827 10.9281 17.7706 10.916C17.7645 10.9039 17.4013 10.359 16.9593 9.70506C16.5233 9.0451 16.0995 8.46385 16.0087 8.40936C15.7786 8.25799 15.3306 8.23377 15.0763 8.36698ZM15.9845 11.6607C16.2327 12.024 16.5052 12.3933 16.596 12.466C16.705 12.5568 17.0743 12.6961 17.6132 12.8414C18.0854 12.9685 18.4669 13.0896 18.4669 13.1078C18.4669 13.126 18.2186 13.4469 17.922 13.8222C17.6192 14.1976 17.3589 14.5791 17.3407 14.6578C17.3165 14.7426 17.3104 15.2148 17.3286 15.7174C17.3528 16.5166 17.3407 16.6195 17.262 16.5832C16.4991 16.2805 15.6757 16.014 15.494 16.014C15.3729 16.014 14.9128 16.1472 14.4708 16.3168C14.0288 16.4803 13.6655 16.6195 13.6595 16.6195C13.6534 16.6195 13.6595 16.2139 13.6716 15.7174C13.6897 15.2148 13.6837 14.7426 13.6595 14.6578C13.6413 14.5791 13.381 14.1976 13.0782 13.8222C12.7815 13.4469 12.5333 13.126 12.5333 13.1078C12.5333 13.0896 12.9147 12.9685 13.387 12.8414C13.9259 12.6961 14.2952 12.5568 14.4042 12.466C14.495 12.3933 14.7675 12.024 15.0157 11.6607C15.2579 11.2914 15.4759 10.9887 15.5001 10.9887C15.5243 10.9887 15.7423 11.2914 15.9845 11.6607Z"
        fill="white"
      />
    </svg>
  );
};
//PLAYLIST ICON
export const PlaylistIcon = () => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 1.61685V3.2334H9.47883H18.9577V1.61685V0.000309706H9.47883H0V1.61685Z"
        fill="white"
      />
      <path
        d="M0 7.78873V9.40527H9.47883H18.9577V7.78873V6.17218H9.47883H0V7.78873Z"
        fill="white"
      />
      <path
        d="M0 14.1086V15.7251H6.31922H12.6384V14.1086V12.492H6.31922H0V14.1086Z"
        fill="white"
      />
      <path
        d="M15.7246 17.2676C15.7246 19.8982 15.7687 22.0291 15.8422 21.9997C16.9444 21.3972 23.6604 17.297 23.6604 17.2235C23.6457 17.1354 16.2096 12.6237 15.8716 12.5209C15.7834 12.4915 15.7246 14.1815 15.7246 17.2676Z"
        fill="white"
      />
    </svg>
  );
};

//LIKE VIDEO ICON
export const LikeVideoIcon = () => {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.69976 12.3688V21.315H5.48726L5.67851 21.3375C9.19476 22.1575 11.5248 22.7488 12.686 23.115C14.2285 23.6013 14.8035 23.72 15.8498 23.79C16.6323 23.8438 17.521 23.5425 17.926 23.13C18.1498 22.9025 18.3173 22.435 18.3835 21.71C18.3972 21.558 18.4516 21.4124 18.5409 21.2886C18.6302 21.1648 18.7511 21.0673 18.891 21.0063C19.2023 20.8713 19.461 20.6513 19.6773 20.3313C19.8773 20.0388 20.0073 19.4938 20.031 18.705C20.0352 18.56 20.0763 18.4185 20.1504 18.2938C20.2246 18.1691 20.3293 18.0654 20.4548 17.9925C21.1823 17.5713 21.5423 17.0963 21.6173 16.5388C21.6998 15.9225 21.4998 15.2288 20.976 14.4388C20.8531 14.2535 20.8074 14.0276 20.8484 13.8091C20.8895 13.5906 21.0142 13.3968 21.196 13.2688C21.6973 12.9163 21.9723 12.4263 22.041 11.7313C22.151 10.6238 21.4448 9.80502 19.846 9.64127C18.4221 9.50044 16.9844 9.62032 15.6035 9.99502C15.4469 10.036 15.2818 10.0313 15.1277 9.98161C14.9736 9.93191 14.8369 9.83923 14.7337 9.71449C14.6305 9.58974 14.565 9.43811 14.5451 9.27744C14.5251 9.11677 14.5515 8.95373 14.621 8.80752C15.246 7.48502 15.5935 6.39377 15.6748 5.54877C15.781 4.42752 15.5223 3.61502 14.9173 2.94502C14.4585 2.43752 13.7248 2.14752 13.4498 2.20752C13.0873 2.28502 12.851 2.49502 12.5435 3.23002C12.3623 3.66502 12.2748 4.03502 12.1248 4.89877C11.981 5.71877 11.9023 6.08877 11.7385 6.57377C11.2448 8.04377 10.0335 9.56752 8.40726 10.6188C7.2675 11.3547 6.03226 11.9309 4.73601 12.3313C4.65503 12.3562 4.57075 12.3689 4.48601 12.3688H1.69976ZM1.64726 23.0188C1.24351 23.03 0.881009 22.94 0.577259 22.7275C0.189759 22.4563 0.00725871 22.0288 0.00350871 21.5363L0.00725871 12.3825C-0.0352413 11.895 0.108509 11.4475 0.448509 11.115C0.767259 10.8025 1.18351 10.655 1.62351 10.665H4.35476C5.45958 10.313 6.51291 9.81617 7.48726 9.18752C8.79726 8.34002 9.76226 7.12502 10.131 6.03002C10.2573 5.65252 10.3248 5.34002 10.4523 4.60502C10.6248 3.61877 10.7323 3.16002 10.9798 2.57002C11.4923 1.34252 12.1648 0.742523 13.0923 0.541273C14.0048 0.343773 15.3335 0.870023 16.1735 1.80002C17.1048 2.83002 17.516 4.11877 17.3635 5.71127C17.2985 6.39627 17.1085 7.16252 16.796 8.01627C17.8632 7.86074 18.9455 7.83723 20.0185 7.94627C22.5273 8.20252 23.936 9.83627 23.731 11.9013C23.641 12.7913 23.3185 13.5475 22.7698 14.1413C23.231 15.03 23.4148 15.9088 23.2998 16.7663C23.1673 17.7538 22.6173 18.5763 21.7023 19.215C21.631 20.0813 21.4323 20.7725 21.0798 21.29C20.802 21.7081 20.4396 22.0633 20.016 22.3325C19.881 23.1875 19.5973 23.8563 19.1335 24.3263C18.3648 25.1088 16.991 25.575 15.736 25.49C14.5448 25.41 13.8398 25.265 12.1773 24.74C11.081 24.3938 8.81101 23.8188 5.38976 23.0188H1.64726ZM3.77351 11.98C3.77318 11.8682 3.79492 11.7574 3.83749 11.654C3.88006 11.5506 3.94262 11.4566 4.02158 11.3774C4.10055 11.2982 4.19436 11.2353 4.29765 11.1925C4.40094 11.1496 4.51167 11.1275 4.62351 11.1275C4.73513 11.1278 4.8456 11.1502 4.9486 11.1932C5.0516 11.2362 5.14512 11.2991 5.22382 11.3782C5.30252 11.4574 5.36485 11.5513 5.40726 11.6545C5.44968 11.7578 5.47134 11.8684 5.47101 11.98V21.5775C5.47117 21.6891 5.44935 21.7997 5.40679 21.9029C5.36422 22.0061 5.30175 22.0999 5.22293 22.1789C5.14412 22.258 5.05051 22.3207 4.94744 22.3636C4.84438 22.4065 4.73388 22.4286 4.62226 22.4288C4.51064 22.4286 4.40014 22.4065 4.29707 22.3636C4.19401 22.3207 4.1004 22.258 4.02158 22.1789C3.94277 22.0999 3.8803 22.0061 3.83773 21.9029C3.79517 21.7997 3.77334 21.6891 3.77351 21.5775V11.98Z"
        fill="white"
      />
    </svg>
  );
};

// NAV SOCIAL ICONS
export const NavNotificationIcon = () => {
  return (
    <svg
      className="group notification_hover_animation"
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="group-hover:fill-[#B98736] duration-200"
        d="M16 15V9.8C15.5 9.9 15 10 14.5 10H14V16H4V9C4 6.2 6.2 4 9 4C9.1 2.7 9.7 1.6 10.5 0.7C10.2 0.3 9.6 0 9 0C7.9 0 7 0.9 7 2V2.3C4 3.2 2 5.9 2 9V15L0 17V18H18V17L16 15ZM7 19C7 20.1 7.9 21 9 21C10.1 21 11 20.1 11 19H7ZM18 4.5C18 6.4 16.4 8 14.5 8C12.6 8 11 6.4 11 4.5C11 2.6 12.6 1 14.5 1C16.4 1 18 2.6 18 4.5Z"
        fill="white"
      />
    </svg>
  );
};
//HEADER MY ACCOUNT ICON
export const NavContactIcon = () => {
  return (
    <svg
      className=" group"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className=" group-hover:fill-[#B98736] duration-200"
        d="M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM5.07 16.28C5.5 15.38 8.12 14.5 10 14.5C11.88 14.5 14.5 15.38 14.93 16.28C13.5294 17.396 11.7909 18.0026 10 18C8.14 18 6.43 17.36 5.07 16.28ZM16.36 14.83C14.93 13.09 11.46 12.5 10 12.5C8.54 12.5 5.07 13.09 3.64 14.83C2.57618 13.4446 1.99967 11.7467 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 11.82 17.38 13.5 16.36 14.83ZM10 4C8.06 4 6.5 5.56 6.5 7.5C6.5 9.44 8.06 11 10 11C11.94 11 13.5 9.44 13.5 7.5C13.5 5.56 11.94 4 10 4ZM10 9C9.60218 9 9.22064 8.84196 8.93934 8.56066C8.65804 8.27936 8.5 7.89782 8.5 7.5C8.5 7.10218 8.65804 6.72064 8.93934 6.43934C9.22064 6.15804 9.60218 6 10 6C10.3978 6 10.7794 6.15804 11.0607 6.43934C11.342 6.72064 11.5 7.10218 11.5 7.5C11.5 7.89782 11.342 8.27936 11.0607 8.56066C10.7794 8.84196 10.3978 9 10 9Z"
        fill="white"
      />
    </svg>
  );
};

//SEND ICON
export const SendIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 512 512">
      <path
        fill="white"
        d="m476.59 227.05l-.16-.07L49.35 49.84A23.56 23.56 0 0 0 27.14 52A24.65 24.65 0 0 0 16 72.59v113.29a24 24 0 0 0 19.52 23.57l232.93 43.07a4 4 0 0 1 0 7.86L35.53 303.45A24 24 0 0 0 16 327v113.31A23.57 23.57 0 0 0 26.59 460a23.94 23.94 0 0 0 13.22 4a24.55 24.55 0 0 0 9.52-1.93L476.4 285.94l.19-.09a32 32 0 0 0 0-58.8Z"
      />
    </svg>
  );
};
//PLAY BUTTON
export const PlayBtnIcon = () => {
  return (
    <svg
      className=" group/item absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50px] h-[50px] md:w-[60px] md:h-[60px]"
      version="1.1"
      id="play"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enableBackground="new 0 0 100 100">
      <path
        className="stroke-solid stroke-[5px] duration-[1s]"
        strokeDasharray="300"
        fill="white"
        stroke="#d4a853"
        d="M49.9,2.5C23.6,2.8,2.1,24.4,2.5,50.4C2.9,76.5,24.7,98,50.3,97.5c26.4-0.6,47.4-21.8,47.2-47.7
    C97.3,23.7,75.7,2.3,49.9,2.5"
      />
      <path
        className="icon duration-200 transform scale-[0.8] group-hover/item:scale-[.9] origin-center"
        fill="#CD9F4C"
        d="M38,69c-1,0.5-1.8,0-1.8-1.1V32.1c0-1.1,0.8-1.6,1.8-1.1l34,18c1,0.5,1,1.4,0,1.9L38,69z"
      />
    </svg>
  );
};
//CHENNAL ICON
export const ChennalIcon = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1301_906)">
        <path
          d="M38.5687 33.253H35.1656L28.9031 15.9974H31.965L35.7525 27.223C35.8931 27.6562 36.2644 28.9105 36.8512 30.9955L37.4081 29.1262L38.0269 27.2399L41.9531 15.9824H45L38.5687 33.253ZM28.5487 33.1293C27.6021 33.3902 26.6244 33.5208 25.6425 33.5174C23.3362 33.5174 22.1925 32.218 22.1925 29.6043V18.0862H20.1994V15.9974H22.3012V13.2768L25.0687 12.148V16.0143H28.2694V18.1012H25.0875V28.9855C25.0875 29.8218 25.2262 30.3918 25.4887 30.733C25.7512 31.0743 26.2312 31.228 26.895 31.228C27.2831 31.228 27.8231 31.1512 28.5506 31.0124L28.5487 33.1293ZM14.88 23.1112C14.9119 26.4187 17.7862 27.5324 17.8181 27.5474C17.7862 27.6262 17.3531 29.1262 16.3031 30.6562C15.39 31.9874 14.4469 33.3149 12.9469 33.3468C11.4787 33.3768 11.0156 32.4805 9.3281 32.4805C7.65935 32.4805 7.13435 33.3149 5.74123 33.3768C4.31998 33.4237 3.22123 31.9237 2.29498 30.5943C0.423729 27.8737 -1.0144 22.9105 0.918729 19.5693C1.87498 17.9005 3.59248 16.8487 5.44873 16.8318C6.85498 16.8018 8.20123 17.7918 9.06748 17.7918C9.93185 17.7918 11.5556 16.6162 13.2562 16.7868C13.9687 16.8168 15.9787 17.0812 17.2612 18.9505C17.1525 19.0124 14.865 20.3437 14.88 23.1112ZM12.1275 14.9774C12.885 14.0493 13.4119 12.7649 13.2712 11.4824C12.1744 11.5293 10.845 12.2099 10.0406 13.138C9.3281 13.9574 8.70935 15.2718 8.87998 16.5243C10.1025 16.618 11.37 15.8905 12.1275 14.9774Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1301_906">
          <rect width="45" height="45" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// SHOPE ICON
export const ShopeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 3.73312L21.6139 11.2106C22.0499 11.5497 22.1284 12.178 21.7893 12.6139C21.4503 13.0499 20.822 13.1284 20.386 12.7893L19 11.7113V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V11.7113L3.61393 12.7893C3.17798 13.1284 2.5497 13.0499 2.21063 12.6139C1.87156 12.178 1.9501 11.5497 2.38604 11.2106L12 3.73312ZM11 19H13V15H11V19ZM15 19V13H9V19H7V10.7223L12 6.59369L17 10.7223V19H15Z"
        fill="white"
      />
    </svg>
  );
};

//FRIEND ICON
export const FriendIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2528 6.03859C15.8471 5.9716 15.4317 5.99201 15.0345 6.09844C14.501 6.24138 13.9527 5.9248 13.8098 5.39133C13.6668 4.85786 13.9834 4.30953 14.5169 4.16658C15.1891 3.98647 15.892 3.95194 16.5786 4.0653C17.2652 4.17866 17.9197 4.4373 18.4983 4.82393C19.077 5.21055 19.5664 5.71626 19.9339 6.30722C20.3014 6.89819 20.5384 7.56081 20.6293 8.25076C20.7201 8.94072 20.6626 9.64211 20.4606 10.3081C20.2586 10.974 19.9167 11.5891 19.4579 12.1124C19.3227 12.2665 19.1783 12.4116 19.0256 12.547C19.7084 12.8902 20.3386 13.3426 20.8891 13.8931C21.1332 14.1372 21.3581 14.3971 21.5628 14.6703C22.0214 15.2826 22.2374 15.965 22.1993 16.6537C22.1619 17.3318 21.883 17.9389 21.4842 18.429C20.6995 19.3935 19.3838 20 18.0045 20H16.8933C16.3411 20 15.8933 19.5523 15.8933 19C15.8933 18.4477 16.3411 18 16.8933 18H18.0045C18.8343 18 19.5597 17.6254 19.9328 17.1668C20.1129 16.9454 20.192 16.7305 20.2024 16.5434C20.2121 16.3669 20.1656 16.1411 19.962 15.8693C19.8141 15.6718 19.6515 15.4839 19.4749 15.3073C18.4955 14.328 17.1673 13.7778 15.7822 13.7778C15.2299 13.7778 14.7822 13.3301 14.7822 12.7778C14.7822 12.2255 15.2299 11.7778 15.7822 11.7778C16.1935 11.7778 16.5999 11.69 16.9745 11.5203C17.349 11.3506 17.6831 11.1028 17.9542 10.7937C18.2253 10.4845 18.4273 10.121 18.5467 9.72749C18.6661 9.33398 18.7001 8.91952 18.6464 8.51181C18.5927 8.10411 18.4526 7.71257 18.2355 7.36336C18.0183 7.01415 17.7291 6.71533 17.3872 6.48687C17.0453 6.2584 16.6585 6.10557 16.2528 6.03859ZM8.22221 6C6.62672 6 5.33332 7.2934 5.33332 8.88889C5.33332 10.4844 6.62673 11.7778 8.22223 11.7778C9.81771 11.7778 11.1111 10.4844 11.1111 8.88889C11.1111 7.2934 9.8177 6 8.22221 6ZM11.4656 12.547C12.475 11.6514 13.1111 10.3444 13.1111 8.88889C13.1111 6.18883 10.9223 4 8.22221 4C5.52215 4 3.33332 6.18883 3.33332 8.88889C3.33332 10.3444 3.96942 11.6514 4.9788 12.547C4.29602 12.8902 3.66583 13.3426 3.11535 13.8931C2.87122 14.1372 2.64633 14.3971 2.4417 14.6703C1.98307 15.2826 1.7671 15.965 1.80513 16.6537C1.84258 17.3318 2.1215 17.9389 2.52026 18.429C3.30495 19.3935 4.62067 20 6.00001 20H10.4445C11.8238 20 13.1395 19.3935 13.9242 18.429C14.323 17.9389 14.6019 17.3318 14.6393 16.6537C14.6774 15.965 14.4614 15.2826 14.0028 14.6703C13.7981 14.3971 13.5732 14.1372 13.3291 13.8931C12.7786 13.3426 12.1484 12.8902 11.4656 12.547ZM8.22223 13.7778C6.83721 13.7778 5.50892 14.328 4.52956 15.3073C4.35297 15.4839 4.19037 15.6718 4.04244 15.8693C3.83888 16.1411 3.79234 16.3669 3.80209 16.5434C3.81242 16.7305 3.89154 16.9454 4.07167 17.1668C4.44476 17.6254 5.1702 18 6.00001 18H10.4445C11.2743 18 11.9997 17.6254 12.3728 17.1668C12.5529 16.9454 12.632 16.7305 12.6424 16.5434C12.6521 16.3669 12.6056 16.1411 12.402 15.8693C12.2541 15.6718 12.0915 15.4839 11.9149 15.3073C10.9355 14.328 9.60725 13.7778 8.22223 13.7778Z"
        fill="white"
      />
    </svg>
  );
};

//FRIEND SIDEBAR MENU ICON
export const FriendMenuIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M2 2H13V4H4V20H13V22H2V2Z" fill="white" />
      <path
        d="M17 6.58579L22.4142 12L17 17.4142L15.5858 16L18.5858 13H7V11H18.5858L15.5858 8L17 6.58579Z"
        fill="white"
      />
    </svg>
  );
};

export const AnnouncementIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-megaphone-fill"
      viewBox="0 0 16 16">
      <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z" />
    </svg>
  );
};

export const ResourceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-archive-fill"
      viewBox="0 0 16 16">
      <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1M.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z" />
    </svg>
  );
};
